import { render, staticRenderFns } from "./TextClamped.vue?vue&type=template&id=fc5338a0&scoped=true&"
import script from "./TextClamped.vue?vue&type=script&lang=js&"
export * from "./TextClamped.vue?vue&type=script&lang=js&"
import style0 from "./TextClamped.vue?vue&type=style&index=0&id=fc5338a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5338a0",
  null
  
)

export default component.exports